import PaginationInput from "./PaginationInput";

document.addEventListener("DOMContentLoaded", () => {
    let paginationInputs = document.querySelectorAll(".js-paginate-input");
    if (paginationInputs.length > 0) {
        paginationInputs.forEach((inp) => {
            new PaginationInput(inp);
        });
    }
});
